var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.262,
    height: 15.648,
    viewBox: "0 0 19.262 15.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Logout",
    d: "M10.7,15.648a2.367,2.367,0,0,1-2.392-2.336v-.984a.957.957,0,0,1,1.913,0v.984a.473.473,0,0,0,.479.467h6.17a.473.473,0,0,0,.479-.467V2.336a.474.474,0,0,0-.479-.468H10.7a.474.474,0,0,0-.479.468V3.553a.947.947,0,0,1-.957.934h0a.947.947,0,0,1-.957-.934V2.336A2.367,2.367,0,0,1,10.7,0H16.87a2.367,2.367,0,0,1,2.392,2.336V13.312a2.367,2.367,0,0,1-2.392,2.336ZM4.183,12.374.283,8.606a.922.922,0,0,1,0-1.329L4.19,3.509a.975.975,0,0,1,1.352.054.924.924,0,0,1-.015,1.281L3.281,7.014H13.687a.949.949,0,0,1,.957.924v0a.947.947,0,0,1-.957.934H3.281L5.532,11.05A.92.92,0,0,1,5.5,12.371a.965.965,0,0,1-.655.254A.982.982,0,0,1,4.183,12.374Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.9cf55e04a20d673a2a7e7ed68a77ca42.svg";
export { ForwardRef as ReactComponent };